import React from 'react'
import { css } from 'emotion'
import * as Header from './Header'
import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import { Link } from 'gatsby'
import { Links } from './Links'
import logo from '../images/esmer-logo.svg'
import 'animate.css/animate.css'

export const HOME_HEADER_HEIGHT = '400px'
export const LOGO_SIZE = '200px'

export const styles = {}
styles.titleWrapper = css`
  width: 100%;
  height: calc(100% - 110px);
  display: flex;
  top: 0;
  left: 0;
  position: absolute;
  justify-content: center;
  .icon-wrapper {
    display: flex;
    flex-flow: column;
    justify-content: center;
    img {
      border-radius: 50%;
      box-shadow: 0 0 32px 18px black;
      background-color: rgba(0, 0, 0, 0.8);
      width: ${LOGO_SIZE};
      height: ${LOGO_SIZE};
    }
  }
`
styles.wrapper = css`
  @import url('https://fonts.googleapis.com/css?family=Kanit');
  ${Header.styles.wrapper}
  min-height: ${HOME_HEADER_HEIGHT};
  max-height: ${HOME_HEADER_HEIGHT};
  .container-wrapper {
    a {
      transition: color 0.5s;
    }
    background-color: transparent;
    transition: background-color 0.5s;
    z-index: 10;
  }
  .container-wrapper.sticky {
    position: fixed;
    top: 0;
    width: 100%;
    background-color: white;
    a {
      color: black;
      transition: color 0.5s;
    }
    transition: background-color 0.5s;
  }
  .title-wrapper {
    ${styles.titleWrapper}
    z-index: 10;
    h1 {
      position: absolute;
      text-align: center;
      color: white;
      font-family: 'Kanit', sans-serif;
      font-size: 64px;
      bottom: 25%;
      text-shadow: 16px 0 16px black, 0 16px 16px black;
      small {
        font-size: 32px;
        color: red;
        position: absolute;
        right: -30px;
        bottom: -30px;
        transform: rotate(-30deg);
        @media (max-width: 430px) {
          display: none;
        }
      }
    }
  }
`

export class HomeHeader extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      scrolled: false,
      stickNav: false,
    }
  }

  componentDidMount() {
    document.onscroll = () => {
      const scrolled = document.documentElement.scrollTop
      this.setState({ stickNav: scrolled > 290, scrolled })
    }
  }

  render() {
    const { title } = this.props
    const { scrolled, stickNav } = this.state
    return (
      <StaticQuery
        query={graphql`
          query HomeHeaderImage {
            file(relativePath: { eq: "home-header-bg.jpeg" }) {
              data: childImageSharp {
                fluid(maxWidth: 2048) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        `}
        render={result => (
          <div className={styles.wrapper}>
            <Img
              fluid={result.file.data.fluid}
              style={Header.styles.headerImageStyle}
            />
            <div className="shade" />
            <div className="title-wrapper">
              <div className="icon-wrapper">
                <img src={logo} alt="Site logo" />
              </div>
              <h1 className={scrolled ? 'animated fadeOut' : 'animated fadeIn'}>
                Esmer Games <small>Blog</small>
              </h1>
            </div>
            <div
              className={['container-wrapper', stickNav && 'sticky'].join(' ')}
            >
              <div className="container">
                <h1
                  style={{ margin: 0 }}
                  className={scrolled ? 'animated fadeIn' : 'animated fadeOut'}
                >
                  <Link to="/">{title}</Link>
                </h1>
                <Links />
              </div>
            </div>
          </div>
        )}
      />
    )
  }
}
